import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "picker-header" }
const _hoisted_2 = ["data-testid"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "selected-data",
      "data-testid": `${_ctx.testid}-custom-picker-header`
    }, _toDisplayString(_ctx.label), 9, _hoisted_2)
  ]))
}